export default "/dist/files/suppression.a2c44cc8036362291d79b20a9304bb3b.svg";